
import axios from "axios";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { DataItemProps } from ".";

interface ApiDataInputProps {
    formCode: string;
    page?: number;
    pageSize?: number;
    q?: string;
    statusIds?: number[];
    hasIds?: number[];
    [key: string]: any
}

type ApiDataOutputProps = OutputBaseProps<{ list: DataItemProps[]; pagination?: PaginationProps; }>

export const apiDataIndex = async ({ formCode, ...data }: ApiDataInputProps) => {
    const res = (await axios.get<ApiDataOutputProps>(`/api/data/${formCode}/index`, { params: data }))
        .data;
    return res;
};

interface ApiDataIdInputProps extends Omit<ApiDataInputProps, "formCode"> {
    formId: number;
}
export const apiDataIdIndex = async ({ formId, ...data }: ApiDataIdInputProps, locale?: string) => {
    const res = (await axios.get<ApiDataOutputProps>(`/api/data/id/${formId}/index`, { params: data, headers: locale ? { locale } : {} }))
        .data;
    return res;
};